exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-image[data-v-146f2066]{width:20vw;max-width:120px}@media (min-width:825px){.v-image[data-v-146f2066]{width:120px}}", ""]);

// exports
